import { createApp } from '@backstage/frontend-defaults';
import { navModule } from './modules/nav';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { identityServerSSO, ssoAuthProviderApiExtension } from './apis';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'plugin.app.sso-auth',
            title: 'Login',
            message: 'Sign in using SSO',
            apiRef: identityServerSSO,
          }}
        />
      ),
  },
});

const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [ssoAuthProviderApiExtension, signInPage],
});

export default createApp({
  features: [navModule, authModule],
});
